import React, { useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { getAllProjectImages } from '../utils/projectImages';
import './ProjectDetail.css';

const ProjectDetail = ({ projects }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const project = projects.find(p => p.id === parseInt(id));
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  if (!project) {
    return (
      <div className="project-detail-page">
        <div className="not-found">
          <h2>Project Not Found</h2>
          <p>The project you're looking for doesn't exist.</p>
          <Link to="/gallery" className="btn btn-primary">Back to Gallery</Link>
        </div>
      </div>
    );
  }

  const projectImages = getAllProjectImages(project.photoDirectory);
  const backgroundImageUrl = process.env.PUBLIC_URL 
    ? `${process.env.PUBLIC_URL}/images/project.png`
    : '/images/project.png';

  const nextImage = () => {
    if (projectImages.length > 0) {
      setCurrentImageIndex((prev) => (prev + 1) % projectImages.length);
    }
  };

  const prevImage = () => {
    if (projectImages.length > 0) {
      setCurrentImageIndex((prev) => (prev - 1 + projectImages.length) % projectImages.length);
    }
  };

  return (
    <div className="project-detail-page">
      <section 
        className="detail-hero"
        style={{
          backgroundImage: `url("${backgroundImageUrl}")`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}
      >
        <div className="detail-hero-content">
          <h1 className="detail-title">{project.name}</h1>
          <div className="detail-badge">{project.type || 'Project'}</div>
        </div>
      </section>

      <section className="detail-section">
        <div className="detail-container">
          <button onClick={() => navigate(-1)} className="back-button">
            ← Back
          </button>
          <div className="detail-grid">
            <div className="detail-main">
              <div className="detail-image-section">
                {projectImages.length > 0 ? (
                  <div className="detail-image-container">
                    <img 
                      src={projectImages[currentImageIndex]}
                      alt={`${project.name} - ${currentImageIndex + 1}`}
                      className="detail-main-image"
                      onError={(e) => {
                        console.error('Failed to load image:', projectImages[currentImageIndex]);
                        e.target.style.display = 'none';
                      }}
                    />
                    {projectImages.length > 1 && (
                      <>
                        <button 
                          className="detail-image-nav detail-image-prev"
                          onClick={prevImage}
                          aria-label="Previous image"
                        >
                          ‹
                        </button>
                        <button 
                          className="detail-image-nav detail-image-next"
                          onClick={nextImage}
                          aria-label="Next image"
                        >
                          ›
                        </button>
                        <div className="detail-image-counter">
                          {currentImageIndex + 1} / {projectImages.length}
                        </div>
                      </>
                    )}
                  </div>
                ) : (
                  <div className="detail-image-placeholder">
                    <span className="detail-icon">🏗️</span>
                  </div>
                )}
              </div>

              <div className="detail-description">
                <h2 className="section-heading">Project Description</h2>
                <p className="description-text">
                  {project.comments || 'No detailed description available for this project.'}
                </p>
              </div>
            </div>

            <div className="detail-sidebar">
              <div className="info-card">
                <h3 className="info-card-title">Project Information</h3>
                <div className="info-list">
                  <div className="info-item">
                    <span className="info-label">Contract Number</span>
                    <span className="info-value">{project.contractNo}</span>
                  </div>
                  <div className="info-item">
                    <span className="info-label">Project Type</span>
                    <span className="info-value">{project.type || 'N/A'}</span>
                  </div>
                  <div className="info-item">
                    <span className="info-label">Start Date</span>
                    <span className="info-value">{project.startDate}</span>
                  </div>
                  <div className="info-item">
                    <span className="info-label">End Date</span>
                    <span className="info-value">{project.endDate}</span>
                  </div>
                  <div className="info-item">
                    <span className="info-label">Budget</span>
                    <span className="info-value highlight">Rs. {project.budget}</span>
                  </div>
                  <div className="info-item">
                    <span className="info-label">Serial Number</span>
                    <span className="info-value">{project.sn}</span>
                  </div>
                </div>
              </div>

              <div className="action-card">
                <Link to="/gallery" className="btn btn-secondary">
                  View All Projects
                </Link>
                <Link to="/contact" className="btn btn-primary">
                  Contact Us
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ProjectDetail;

